import { Component, OnInit, TemplateRef, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BnModalMessageService } from '@bndes/bndes-ux4/bn-modal-message';
import { MessageChannelService, messageLevel } from '@bndes/bndes-ux4/bndes-angular-utils';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { ModalidadeGarantia } from 'src/app/model/modalidade_garantia.model';
import { ModalidadeGarantiaService } from '../../modalidade_garantia/modalidade-garantia.service';
import { LimiteAdicionalService } from '../limite-adicional.service';
import { LimiteAdicionalTrancheAgenteFinanceiro } from 'src/app/model/limite-adicional-tranche-agente-financeiro.model';
import { OpcaoFiltro } from 'src/app/model/opcao-filtro.model';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';

@Component({
  selector: 'app-limite-adicional-pesquisa',
  templateUrl: './limite-adicional-pesquisa.component.html',
  styleUrls: ['./limite-adicional-pesquisa.component.scss'],
  standalone: false,
})
export class LimiteAdicionalPesquisaComponent implements OnInit {
  public limitesAdicionais: LimiteAdicionalTrancheAgenteFinanceiro[] = [];
  public tranches: Tranche[] = [];
  public ideTranche: number;
  public pesquisado = false;
  public podeCadastrar: boolean;
  public idAgenteFinanceiro: number;
  public idLimiteAdicional: number;
  public codigoPrograma: string;
  public agentesFinanceiros: OpcaoFiltro[] = [];
  public limitesAdicionaisOpcoes: OpcaoFiltro[] = [];
  public codigo: number;
  public descricao: string;
  public esco: boolean;
  public modalidade: ModalidadeGarantia;
  public dataAtualizacaoListagem: Date;

  @ViewChild('botoesCadastroTipo') botoesCadastroTipo: TemplateRef<any>;
  @ViewChild('bodyCadastroTipo') bodyCadastroTipo: TemplateRef<any>;
  @ViewChild('botoesCadastroLimite') botoesCadastroLimite: TemplateRef<any>;
  @ViewChild('bodyCadastroLimite') bodyCadastroLimite: TemplateRef<any>;

  constructor(
    private modalidadeGarantiaService: ModalidadeGarantiaService,
    private trancheService: TrancheService,
    private limiteAdicionalService: LimiteAdicionalService,
    private permissaoService: PermissaoService,
    private modalService: BnModalMessageService,
    private activatedRoute: ActivatedRoute,
    private messageService: MessageChannelService,
    private router: Router,
    private agenteFinanceiroService: AgenteFinanceiroService
  ) {}

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscarTodosPorTranche();
  }

  ngOnInit(): void {

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
      this.podeCadastrar = resp && resp[ROLE_GESTOR_ENVIO];

      this.modalidadeGarantiaService.buscarModalidade().subscribe((modalidade: any) => {
        this.modalidade = modalidade;
      });
    });

    this.trancheService.getTranches().subscribe(tranches => {
      this.tranches = tranches;

      const state = history.state;

      if (state?.voltarComCesta && state?.cesta) {

        const t = this.tranches.find(x => x.id == Number(state.cesta));

        if (t) {
          this.ideTranche = t.id;
          this.buscaTranche();
          this.buscarTodosPorTranche();
        }

        history.replaceState({}, document.title);
      }
    });
  }

  public buscaTranche() {
    this.idAgenteFinanceiro = null;
    this.idLimiteAdicional = null;
    this.agentesFinanceiros = [];
    this.limitesAdicionaisOpcoes = [];

    if (!this.ideTranche) {
      return;
    }

    this.agenteFinanceiroService.getAgentesFinanceiros().subscribe((agentes: AgenteFinanceiro[]) => {
      for (let agente of agentes) {
        this.agentesFinanceiros.push({
          id: agente.id,
          descricao: agente.nome + '(' + agente.cnpj + ')'
        });
      }
    });

    this.trancheService.buscarLimitesAdicionaisTranche(this.ideTranche).subscribe(limites => {
      for (let limite of limites) {
        this.limitesAdicionaisOpcoes.push({
          id: limite['id'],
          descricao: limite['nome']
        });
      }

    });
    this.buscarTodosPorTranche();
  }

  public buscarTodosPorTranche() {
    if (!this.ideTranche) {
      return;
    }

    this.pesquisado = false;
    const dto = this.tratarInformacoesPreenchidas();

    this.limiteAdicionalService.buscarTodosComFiltro(this.ideTranche, dto).subscribe((res: any) => {
      this.limitesAdicionais = res.resultados;
      this.dataAtualizacaoListagem = new Date();
      this.pesquisado = true;
    });
  }

  private tratarInformacoesPreenchidas(): any {
    const dto: any = {};

    if (this.idAgenteFinanceiro) {
      dto.idAgenteFinanceiro = this.idAgenteFinanceiro;
    }

    if (this.idLimiteAdicional) {
      dto.idLimiteAdicional = this.idLimiteAdicional;
    }

    if (this.codigoPrograma && this.codigoPrograma.trim() !== '') {
      dto.codigoPrograma = this.codigoPrograma.trim();
    }

    return dto;
  }

  public limpar() {
    this.ideTranche = null;
    this.idAgenteFinanceiro = null;
    this.idLimiteAdicional = null;
    this.codigoPrograma = null;
    this.agentesFinanceiros = [];
    this.limitesAdicionaisOpcoes = [];
    this.pesquisado = false;
  }

  navegarCadastrarLimite() {
    this.router.navigate([`limite-adicional/cadastro/${this.ideTranche}`]);
  }

  navegarEditarLimite() {
    this.router.navigate([`limite-adicional/listar/${this.ideTranche}`]);
  }

  navegarCadastrarLimitePorAgente() {
    this.router.navigate([`limite-adicional/limite-af/cadastro/${this.ideTranche}`]);
  }

  navegarEditarLimitePorAgente() {
    this.router.navigate([`limite-adicional/limite-af/edicao/${this.ideTranche}`]);
  }


}
